<template>
    <div class="content-block">
        <div class="content-fields">
            <div class="header-text">
                <strong>Компания</strong>
            </div>
            <div class="td-line text-content">
                <p class="item-info">Название:</p>
                <span class="item-info" v-if="!redact">{{company.name}} </span>
                <input class="form-input" v-else type="" name="" v-model="form.name">
            </div>
            <div class="td-line text-content">
                <p class="item-info">Директор:</p>
                <span class="item-info" v-if="!redact">{{company.director}}</span>
                <input class="form-input" v-else type="" name="" v-model="form.director">
            </div>
            <div class="td-line text-content">
                <p class="item-info">ОГРН:</p>
                <span class="item-info" v-if="!redact">{{company.ogrn}}</span>
                <input class="form-input" v-else type="" name="" v-model="form.ogrn">
            </div>
            <div class="td-line text-content">
                <p class="item-info">ИНН: </p>
                <span class="item-info" v-if="!redact">{{company.inn}}</span>
                <input class="form-input" v-else type="" name="" v-model="form.inn">
            </div>    
            <div class="td-line text-content">
                <p class="item-info">Банк: </p>
                <span class="item-info" v-if="!redact">
                  <p v-if="bank_default">{{ bank_default.bank_name }} <span class="add-link" @click="ExecutorRoute">Добавить</span></p>
                  <p v-else @click="ExecutorRoute">Нет счетов</p>

                </span>
                <select class="imput-block-item" v-else id="tariffType" v-model="changeBank" @change="updateBank">
                  <option v-for="bank in company.bank_details" :key="bank.id" :value="bank.id">{{ bank.bank_name }}</option>
                </select>
            </div>
        </div>

        <div class="content-buttons">
            <div class="button-container" v-if="!redact">
                <button class="redact-btn" @click="openClose">Изменить</button>
                <!-- <button class="redact-btn button-send" @click="sendOrder">Отправить заявку</button> -->
            </div>
            <div v-else class="button-container">
                <button class="redact-btn" @click="openClose">Отмена</button>
                <button class="redact-btn" @click="saveForm">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue'
import { saveExecutorForm } from '@/pages/trip/helpers/saveExecutorForm.mjs'

export default {
  name: 'CardCompanyExecetor',
  props: ['company','bank_default','bank_default_id'],
  setup(props,{emit}){
    const redact = ref(false)
    const changeBank = ref(props.bank_default_id)
    const form = ref({
        id:props.company.id,
        name:props.company.name,
        director:props.company.director,
        ogrn:props.company.ogrn,
        inn:props.company.inn,
    })
    
    const updateBank = () =>{
      emit('updateBank',changeBank.value)
    }

    const saveForm = async () =>{
      const saved = await saveExecutorForm(emit, { form: form.value, model: 'companies' })
      if (!saved) return
      redact.value = false
    }
    
    const openClose = () =>{
        redact.value = !redact.value
    }
    const ExecutorRoute = ()=>{
      emit('ExecutorRoute')
    }

    const sendOrder = ()=>{
      emit('sendOrder')
    }

    return{
      sendOrder,
      ExecutorRoute,
      updateBank,
      changeBank,
      openClose,
      redact,
      saveForm,
      form,
    }
  }
};
</script>

<style scoped>

.content-block{
  border: 1px solid #ccc;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  
}

.content-fields{
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
}

.content-buttons{
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}


.status-label{
  margin-bottom: 20px;
}

.td-line{
  border-bottom: 1px solid #ccc;
  width: 100%;
}

.text-content{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2px 15px ;
}

.item-info{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2px;
}


.form-input{
  padding: 2px;
  border-radius: 3px;
  border: 1px solid #ccc;
  margin-bottom: 3px;
  width: 160px;
}

.tms-status{
    width: 100%;
}

.button-container {
  margin-top: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}

.redact-btn {
  padding: 4px;
  margin-left: 5px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.header-text{
    padding: 5px;
    margin-top: 15px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    background-color: rgba(204, 204, 204, 0.5);
}

.add-link{
  margin-left: 10px;
  color: #4398f0;
  text-decoration: underline;
}
.add-link:hover{
  cursor: pointer;
}

.button-send{
  background-color: #007bff;
  color: white;
}
</style>
